import { Component, Input, Output, EventEmitter } from '@angular/core';
import { VIEW_ALL_TYPES } from '@app/mpp/shared/enum/ingredient-enum';

@Component({
  selector: 'app-view-all-launcher',
  templateUrl: './view-all-launcher.component.html',
  styleUrls: ['./view-all-launcher.component.scss'],
})
export class ViewAllLauncherComponent {
  @Input() viewAllState: VIEW_ALL_TYPES;
  @Output() clickEvent: EventEmitter<void> = new EventEmitter();
  viewRef = VIEW_ALL_TYPES;
  constructor() {}

  onClick = () => {
    this.clickEvent.emit();
  };
}
